import axiosIns from "@/api/axios";

// import axiosIns from "../dummy";

export const GET_ALL_REQUESTOR = (args) => {
  return axiosIns.get(`/users/search?${args}`);
};
export const GET_ALL_GG = (args) => {
  return axiosIns.get(`/users/genta-gendis/list?${args}`);
};
export const GET_ALL_USERS_BYROLE = (params) => {
  return axiosIns.get(`/users-by-role`, {
    params,
  });
};
